module.exports = __webpack_public_path__ + "img/delete.67b6b4f9.svg";